import { atom } from 'jotai';

import { createSetAtom } from '~shared/atoms/utils/createSetAtom';

export const extractQuestionsPositionAtom = atom(1);

export const extractQuestionsPaywallAtom = atom(false);

export const extractQuestionsPollingFailedAtom = atom(false);

export const extractQuestionsStepAtom = atom<
  'form' | 'loading' | 'results' | 'error'
>('form');

export const extractQuestionsRequestIdAtom = atom<string | null>(
  null as string | null
);

export const extractAddedQuestionSetAtom = createSetAtom<string>(
  new Set<string>()
);
